import { render } from "./BaseToast.vue?vue&type=template&id=310408fb"
import script from "./BaseToast.vue?vue&type=script&lang=js"
export * from "./BaseToast.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseToast.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "310408fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('310408fb', __exports__)) {
    console.log('reload')
    api.reload('310408fb', __exports__)
  }
  
  module.hot.accept("./BaseToast.vue?vue&type=template&id=310408fb", () => {
    console.log('re-render')
    api.rerender('310408fb', render)
  })

}


export default __exports__